<template>
  <div class="tables-merge-wrapper">
    <table>
      <tr>
        <th>
          Trường thông tinTrường th ông tinTrườngthông tinTrường thông tinTrường
          thông tin
        </th>
        <th>Kết quả</th>
      </tr>
      <tr>
        <td>.</td>
        <td>.</td>
      </tr>
      <tr v-for="(item, index) in resultData" :key="index">
        <td>
          {{ item.label }}
        </td>
        <td>
          {{ item.value }}
        </td>
      </tr>
    </table>
    <table>
      <tr>
        <th v-for="column in columns" :key="column">
          ID:
          {{ column }}
        </th>
      </tr>
      <tr>
        <td
          v-for="cellId in columns"
          :key="cellId"
          :class="{
            selected: cellId == selectedAllId
          }"
          @click="onClickSelectAll(cellId)"
        >
          Chọn tất cả
        </td>
      </tr>
      <tr
        v-for="(rowItem, rowIndex) in rows"
        :id="`row-${rowIndex}`"
        :key="rowIndex"
        @click.capture="onClickRows($event, rowIndex)"
      >
        <td
          v-for="cellId in columns"
          :key="cellId"
          :class="{
            selected: cellId == resultData[rowIndex].id
          }"
          @click="onClickCell($event, cellId, rowIndex, rowItem[cellId])"
        >
          {{ rowItem[cellId] }}
        </td>
        <!-- <td @click="onClickCell($event, index, item['1'] )">{{ item["1"] }}</td>
        <td @click="onClickCell($event, index, item['2'] )">{{ item["2"] }}</td>
        <td @click="onClickCell($event, index, item['3'] )">{{ item["3"] }}</td> -->
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataTable: [
        {
          id: 20201512,
          name: 'Nguyen Van A',
          university: 'DHBK'
        },
        {
          id: 20191234,
          name: 'Nguyen Thi B',
          university: 'FPT'
        },
        {
          id: 20180101,
          name: 'Tran Van C',
          university: 'NEU'
        }
      ],
      resultData: [
        {
          label: 'Name',
          value: null,
          id: null
        },
        {
          label: 'University',
          value: null,
          id: null
        }
      ],
      columns: [],
      rows: [],
      selectedAllId: null
    }
  },
  watch: {
    resultData: {
      deep: true,
      handler(val) {
        const isSelectedAll = this.resultData.every(item => {
          return item.id === this.resultData[0].id
        })

        this.selectedAllId = isSelectedAll ? this.resultData[0].id : null
      }
    }
  },
  mounted() {
    this.columns = this.dataTable.map(item => item.id)
    this.rows = this.convertTableData(this.dataTable)
  },
  methods: {
    convertTableData(dataTable) {
      const result = []
      const keys = Array.from(
        new Set(dataTable.flatMap(item => Object.keys(item)))
      )

      keys.forEach(key => {
        if (key !== 'id') {
          const newObj = {}
          dataTable.forEach(data => {
            newObj[data.id] = data[key]
          })

          result.push(newObj)
        }
      })

      return result
    },
    onClickRows(e, index) {
      const row = e.currentTarget
      // eslint-disable-next-line no-unused-vars
      var cells = row.getElementsByTagName('td')
    },
    onClickCell(e, cellId, rowIndex, value) {
      // V1

      // V2
      this.resultData[rowIndex].value = value
      this.resultData[rowIndex].id = cellId
    },
    onClickSelectAll(id) {
      this.resultData = this.resultData.map(item => {
        return {
          ...item,
          id: id
        }
      })

      this.rows.forEach((item, index) => {
        this.resultData[index].value = item[id]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tables-merge-wrapper {
  display: flex;
}

td.selected {
  background: wheat !important;
}
</style>
